// Script for dark mode toggle
if (localStorage.getItem('darkMode') === 'dark' || ((!('darkMode' in localStorage)) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.documentElement.classList.add('dark');
} else {
    document.documentElement.classList.remove('dark');
}

function toggleDarkMode() {
    if (document.documentElement.classList.contains('dark')) {
        document.documentElement.classList.remove('dark');
        localStorage.setItem('darkMode', 'light');
    } else {
        document.documentElement.classList.add('dark');
        localStorage.setItem('darkMode', 'dark');
    }
}

// Initialize dropdown immediately before page renders
(function() {
    // Create dropdown on initial load to prevent flickering
    if (window.innerWidth >= 768) { // 768px is the md breakpoint in Tailwind
        const mainNav = document.getElementById('main-nav');
        if (mainNav && mainNav.querySelectorAll('li').length > 6) {
            // The dropdown will be created immediately by setupDesktopNavDropdown
            // when the document is ready
            document.documentElement.classList.add('dropdown-pending');
        }
    }
})();

// Menu functionality
document.addEventListener('DOMContentLoaded', function() {
    // Mobile menu functionality
    setupMobileMenu();
    
    // Desktop dropdown menu functionality - run immediately
    if (window.innerWidth >= 768) {
        setupDesktopNavDropdown();
        document.documentElement.classList.remove('dropdown-pending');
    }
    
    // Bookmark functionality
    setupBookmarkFeature();
    
    // Load more posts functionality
    setupLoadMorePosts();
    
    // Initialize table of contents if it exists
    initToc();
    
    // Setup smooth scrolling for on-page links
    setupSmoothScrolling();
});

// Function to setup mobile menu
function setupMobileMenu() {
    const mobileMenuButton = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    const menuContent = document.getElementById('mobile-menu-content');
    const closeButton = document.getElementById('close-mobile-menu');
    const menuBackdrop = document.getElementById('mobile-menu-backdrop');
    
    if (!mobileMenuButton || !mobileMenu) return;
    
    // Function to open menu with animation
    const openMenu = () => {
        // First make the container visible
        mobileMenu.classList.remove('hidden');
        
        // Prevent body scrolling
        document.body.classList.add('overflow-hidden');
        
        // Small delay to ensure the transitions work
        setTimeout(() => {
            // Animate the drawer sliding in from left
            menuContent.classList.remove('-translate-x-full');
            
            // Animate the backdrop sliding in from right
            menuBackdrop.classList.remove('translate-x-full');
        }, 10);
        
        // Update aria attributes
        mobileMenuButton.setAttribute('aria-expanded', 'true');
    };
    
    // Function to close menu with animation
    const closeMenu = () => {
        // First animate the drawer sliding out to left
        menuContent.classList.add('-translate-x-full');
        
        // Animate the backdrop sliding out to right
        menuBackdrop.classList.add('translate-x-full');
        
        // Wait for animations to finish before hiding the container
        setTimeout(() => {
            mobileMenu.classList.add('hidden');
            document.body.classList.remove('overflow-hidden');
        }, 300); // Match the duration in the CSS (300ms)
        
        // Update aria attributes
        mobileMenuButton.setAttribute('aria-expanded', 'false');
    };
    
    // Toggle mobile menu visibility
    mobileMenuButton.addEventListener('click', function() {
        const isExpanded = mobileMenuButton.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
            closeMenu();
        } else {
            openMenu();
        }
    });
    
    // Close menu with X button
    if (closeButton) {
        closeButton.addEventListener('click', closeMenu);
    }
    
    // Close menu when clicking on backdrop
    if (menuBackdrop) {
        menuBackdrop.addEventListener('click', closeMenu);
    }
    
    // Close menu when clicking links
    const menuLinks = mobileMenu.querySelectorAll('a');
    menuLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });
}

// Function to handle the desktop navigation dropdown
function setupDesktopNavDropdown() {
    const mainNav = document.getElementById('main-nav');
    if (!mainNav) return;
    
    // Remove any existing dropdown first (cleanup)
    const existingDropdown = document.getElementById('desktop-nav-more');
    if (existingDropdown) {
        existingDropdown.remove();
    }
    
    // Get all navigation items (excluding any existing dropdown)
    const navItems = Array.from(mainNav.querySelectorAll('li:not(#desktop-nav-more)'));
    
    // Maximum number of visible items before dropdown
    const maxVisibleItems = 5;
    
    // Only proceed if we have more than maxVisibleItems
    if (navItems.length <= maxVisibleItems) {
        // Make all items visible in case we're coming from mobile
        navItems.forEach(item => {
            item.style.display = '';
        });
        return;
    }
    
    // Create "More" dropdown button
    const moreDropdownLi = document.createElement('li');
    moreDropdownLi.className = 'relative';
    moreDropdownLi.id = 'desktop-nav-more';
    
    const moreButton = document.createElement('button');
    moreButton.className = 'flex items-center navbar-link font-medium';
    moreButton.setAttribute('aria-expanded', 'false');
    moreButton.setAttribute('aria-haspopup', 'true');
    moreButton.id = 'desktop-more-button';
    moreButton.innerHTML = `
        <span>More</span>
        <i class="fa-solid fa-angle-down ml-1"></i>
    `;
    
    // Create dropdown container
    const dropdownDiv = document.createElement('div');
    dropdownDiv.className = 'hidden absolute right-0 mt-6 w-max rounded-lg shadow-lg p-2 bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 z-20';
    dropdownDiv.id = 'desktop-dropdown-container';
    
    // Create dropdown list
    const dropdownUl = document.createElement('ul');
    dropdownUl.id = 'desktop-dropdown-list';
    
    // Add items to the dropdown
    for (let i = maxVisibleItems; i < navItems.length; i++) {
        const item = navItems[i];
        
        // Get the link from the original item
        const link = item.querySelector('a');
        if (!link) continue;
        
        // Create new list item for dropdown
        const dropdownLi = document.createElement('li');
        const dropdownLink = document.createElement('a');
        dropdownLink.href = link.href;
        dropdownLink.className = 'block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg';
        dropdownLink.textContent = link.textContent;
        
        // Add to dropdown
        dropdownLi.appendChild(dropdownLink);
        dropdownUl.appendChild(dropdownLi);
    }
    
    // Assemble dropdown
    dropdownDiv.appendChild(dropdownUl);
    moreDropdownLi.appendChild(moreButton);
    moreDropdownLi.appendChild(dropdownDiv);
    
    // Add dropdown to nav
    mainNav.appendChild(moreDropdownLi);
    
    // Named event handler for document clicks
    const desktopDocumentClickHandler = function(e) {
        // Only run this for desktop dropdown, not mobile menu
        if (moreDropdownLi && !moreDropdownLi.contains(e.target)) {
            dropdownDiv.classList.add('hidden');
            moreButton.setAttribute('aria-expanded', 'false');
            moreButton.querySelector('svg')?.classList.remove('rotate-180');
        }
    };
    
    // Handle dropdown toggle with click event (separate from mobile menu)
    moreButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling to document
        
        dropdownDiv.classList.toggle('hidden');
        const expanded = moreButton.getAttribute('aria-expanded') === 'true';
        moreButton.setAttribute('aria-expanded', !expanded);
        moreButton.querySelector('svg').classList.toggle('rotate-180');
    });
    
    // Clean up old event listeners before adding new ones
    document.removeEventListener('click', desktopDocumentClickHandler);
    document.addEventListener('click', desktopDocumentClickHandler);
}

// Add window resize and load event listeners
window.addEventListener('resize', handleResize);
window.addEventListener('load', function() {
    // Ensure the dropdown is set up on initial load
    if (window.innerWidth >= 768) {
        setupDesktopNavDropdown();
    }
});

function handleResize() {
    const mainNav = document.getElementById('main-nav');
    if (!mainNav) return;
    
    if (window.innerWidth >= 768) {
        // If switching to desktop from mobile, hide mobile menu if open
        const mobileMenu = document.getElementById('mobile-menu');
        const menuContent = document.getElementById('mobile-menu-content');
        const menuBackdrop = document.getElementById('mobile-menu-backdrop');
        const mobileMenuButton = document.getElementById('mobile-menu-button');
        
        if (mobileMenu && !mobileMenu.classList.contains('hidden')) {
            // First animate the drawer sliding out to left
            if (menuContent) menuContent.classList.add('-translate-x-full');
            
            // Animate the backdrop sliding out to right
            if (menuBackdrop) {
                menuBackdrop.classList.add('translate-x-full');
            }
            
            // Wait for animations to finish before hiding the container
            setTimeout(() => {
                mobileMenu.classList.add('hidden');
                document.body.classList.remove('overflow-hidden');
                if (mobileMenuButton) mobileMenuButton.setAttribute('aria-expanded', 'false');
            }, 300);
        }
        
        // Setup desktop dropdown when in desktop view
        setupDesktopNavDropdown();
    } else {
        // In mobile view, ensure all nav items are visible
        const navItems = mainNav.querySelectorAll('li');
        navItems.forEach(item => {
            item.style.display = '';
        });
        
        // Remove desktop dropdown if exists
        const desktopMore = document.getElementById('desktop-nav-more');
        if (desktopMore) {
            desktopMore.remove();
        }
    }
}

// Share functionality
function setupBookmarkFeature() {
    // Setup share button if available
    const shareButton = document.getElementById('share-button');
    if (shareButton) {
        shareButton.addEventListener('click', function(e) {
            e.preventDefault();
            shareCurrentPage();
        });
    }
}

function shareCurrentPage() {
    const pageTitle = document.title;
    const pageUrl = window.location.href;
    
    // Use Web Share API if available
    if (navigator.share) {
        navigator.share({
            title: pageTitle,
            url: pageUrl
        }).catch((error) => {
            console.log('Sharing failed:', error);
            // Fallback if share is cancelled or fails
            copyToClipboard(pageUrl);
        });
    } else {
        // Fallback to copying URL to clipboard
        copyToClipboard(pageUrl);
    }
}

function copyToClipboard(text) {
    // Try to use the modern clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
            .then(() => {
                showToast('URL copied to clipboard');
            })
            .catch((error) => {
                console.error('Failed to copy using Clipboard API:', error);
                // If that fails, try the older approach
                fallbackCopyToClipboard(text);
            });
    } else {
        console.log('Clipboard API not available, using fallback');
        // Use fallback for browsers without clipboard API
        fallbackCopyToClipboard(text);
    }
}

function fallbackCopyToClipboard(text) {
    // Create temporary element
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // Make the textarea part of the document but not visible
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    textArea.style.top = '-9999px';
    textArea.style.opacity = '0';
    textArea.setAttribute('readonly', ''); // Prevent keyboard from showing on mobile
    
    document.body.appendChild(textArea);
    
    // Check if we're on iOS
    const isIOS = navigator.userAgent.match(/ipad|iphone/i);
    
    if (isIOS) {
        // Create a range and select it
        const range = document.createRange();
        range.selectNodeContents(textArea);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        textArea.setSelectionRange(0, 999999);
    } else {
        // For other platforms
        textArea.select();
    }
    
    let success = false;
    try {
        success = document.execCommand('copy');
    } catch (err) {
        console.error('execCommand error:', err);
    }
    
    // Clean up
    document.body.removeChild(textArea);
    
    if (success) {
        showToast('URL copied to clipboard');
    } else {
        showToast('Unable to copy URL. Please copy it manually.');
        // Show manual instructions
        console.log('Copy this URL manually:', text);
    }
}

function showToast(message) {
    // Remove any existing toasts first
    const existingToasts = document.querySelectorAll('.toast-notification');
    existingToasts.forEach(toast => {
        document.body.removeChild(toast);
    });
    
    // Create toast element
    const toast = document.createElement('div');
    toast.className = 'toast-notification fixed bottom-4 left-4 bg-gray-800 text-white px-6 py-3 rounded-lg shadow-lg transform transition-all duration-300 opacity-0 translate-y-2 z-50';
    
    // Add message with icon
    toast.innerHTML = `
        <div class="flex items-center">
            <i class="fas fa-check-circle text-green-400 mr-2"></i>
            <span>${message}</span>
        </div>
    `;
    
    // Add to DOM
    document.body.appendChild(toast);
    
    // Trigger animation
    setTimeout(() => {
        toast.classList.remove('opacity-0', 'translate-y-2');
    }, 10);
    
    // Remove after 3 seconds
    setTimeout(() => {
        toast.classList.add('opacity-0', 'translate-y-2');
        setTimeout(() => {
            if (document.body.contains(toast)) {
                document.body.removeChild(toast);
            }
        }, 300);
    }, 3000);
}

// Function to handle loading more posts
function setupLoadMorePosts() {
    const loadMoreButton = document.getElementById('load-more-posts');
    if (!loadMoreButton) return;
    
    // Store original button text
    const originalButtonText = loadMoreButton.textContent.trim();
    
    // Helper functions
    const showLoading = () => {
        loadMoreButton.innerHTML = '<i class="fas fa-circle-notch fa-spin mr-2"></i> Loading...';
        loadMoreButton.disabled = true;
    };
    
    const hideLoading = () => {
        loadMoreButton.innerHTML = originalButtonText;
        loadMoreButton.disabled = false;
    };
    
    const hideButton = () => loadMoreButton.style.display = 'none';
    
    // Check if more posts exist at specified URL
    const checkMorePosts = async (url) => {
        try {
            const response = await fetch(url);
            if (!response.ok) return false;
            
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const posts = doc.querySelectorAll('.article-card');
            
            return posts.length > 0;
        } catch (error) {
            console.error('Error checking for more posts:', error);
            return false;
        }
    };
    
    // Generate next page URL
    const getNextPageUrl = (page) => {
        const path = window.location.pathname;
        const normalizedPath = path.endsWith('/') ? path : `${path}/`;
        return `${window.location.origin}${normalizedPath}page/${page}/`;
    };

    // Check initial state - hide button if no more posts
    (async () => {
        loadMoreButton.style.visibility = 'hidden';
        const hasMorePosts = await checkMorePosts(getNextPageUrl(parseInt(loadMoreButton.dataset.page, 10)));
        
        if (hasMorePosts) {
            loadMoreButton.style.visibility = 'visible';
        } else {
            hideButton();
        }
    })();
    
    // Handle click event
    loadMoreButton.addEventListener('click', async function() {
        const nextPage = parseInt(loadMoreButton.dataset.page, 10);
        const postsPerPage = parseInt(loadMoreButton.dataset.postsPerPage, 10) || 6;
        
        try {
            showLoading();
            
            // Fetch and process the next page
            const nextPageUrl = getNextPageUrl(nextPage);
            const response = await fetch(nextPageUrl);
            if (!response.ok) throw new Error('Failed to load more posts');
            
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const postsContainer = document.querySelector('.article-cards');
            const newPosts = Array.from(doc.querySelectorAll('.article-card'));
            
            // Add new posts to the page
            if (newPosts.length > 0) {
                newPosts.forEach(post => postsContainer.appendChild(post.cloneNode(true)));
                
                // Update page number for next load
                loadMoreButton.dataset.page = nextPage + 1;
                
                // Check if there are more posts for the next page
                const hasMorePosts = 
                    newPosts.length >= postsPerPage && 
                    await checkMorePosts(getNextPageUrl(nextPage + 1));
                
                if (!hasMorePosts) {
                    hideButton();
                }
            } else {
                hideButton();
            }
        } catch (error) {
            console.error('Error loading more posts:', error);
            if (loadMoreButton.style.visibility === 'visible') {
                showToast('Failed to load more posts. Please try again later.');
            }
        } finally {
            hideLoading();
        }
    });
}

// Function to initialize table of contents with tocbot
function initToc() {
    // Check if we're on a page with TOC elements
    const tocElement = document.querySelector('.js-toc');
    const contentElement = document.querySelector('.js-toc-content');
    
    if (!tocElement || !contentElement) return;
    
    // Check if we have any h2 elements in the content
    const h2Elements = contentElement.querySelectorAll('h2');
    const hasH2Elements = h2Elements.length > 0;
    
    // Get the TOC container (parent element of .js-toc)
    const tocContainer = tocElement.closest('.mb-8');
    
    if (!hasH2Elements) {
        // Hide the entire TOC section if no h2 elements exist
        if (tocContainer) {
            tocContainer.style.display = 'none';
        }
        return; // Exit the function early
    }
    
    // Ensure TOC is visible if h2 elements exist
    if (tocContainer) {
        tocContainer.style.display = '';
    }
    
    // Make sure all h2 elements have IDs
    h2Elements.forEach((heading, index) => {
        if (!heading.id) {
            heading.id = 'heading-' + (index + 1);
        }
    });

    // Initialize tocbot if the library is loaded
    if (typeof tocbot !== 'undefined') {
        // If tocbot was previously initialized, reset it
        if (tocElement.hasChildNodes()) {
            tocbot.destroy();
        }
        
        // Initialize tocbot with configuration
        tocbot.init({
            // Where to render the table of contents
            tocSelector: '.js-toc',
            // Where to grab the headings to build the table of contents
            contentSelector: '.js-toc-content',
            // Which headings to grab inside of the contentSelector element
            headingSelector: 'h2',
            // Ensure unique IDs are generated for headings without IDs
            hasInnerContainers: true,
            // How many heading levels to show
            collapseDepth: 6,
            // Turn off smooth scrolling to use our own
            scrollSmooth: false
        });
        
        // Override the default link click behavior for better scrolling
        document.querySelectorAll('.js-toc a').forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);
                
                if (targetElement) {
                    // Get position with a small offset for readability
                    const smallOffset = 80; // Small offset for readability
                    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - smallOffset;
                    
                    // Scroll to the target with small offset
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });
        
    } else {
        console.warn('Tocbot library not loaded');
    }
}

// Back to top button functionality
document.addEventListener('DOMContentLoaded', function() {
    const backToTopButton = document.getElementById('back-to-top');
    
    // Only setup event listeners if the button exists
    if (backToTopButton) {
        // Show button when user scrolls down 300px
        window.addEventListener('scroll', function() {
            if (window.scrollY > 300) {
                backToTopButton.classList.remove('opacity-0', 'invisible');
                backToTopButton.classList.add('opacity-100', 'visible');
            } else {
                backToTopButton.classList.remove('opacity-100', 'visible');
                backToTopButton.classList.add('opacity-0', 'invisible');
            }
        });
        
        // Scroll to top when button is clicked
        backToTopButton.addEventListener('click', function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
});

// Function to handle smooth scrolling for all on-page links
function setupSmoothScrolling() {
    // Get all links that point to an ID on the current page
    const links = document.querySelectorAll('a[href^="#"]:not(.js-toc a)');
    
    links.forEach(link => {
        // Skip links that are just "#" or javascript:void(0)
        if (link.getAttribute('href') === '#' || link.getAttribute('href') === '#/') return;
        
        link.addEventListener('click', function(e) {
            // Extract the target ID from href
            const targetId = this.getAttribute('href');
            
            // Skip if it's a functional link like #/portal/signup
            if (targetId.includes('/')) return;
            
            const targetElement = document.querySelector(targetId);
            
            // Only handle if the target element exists
            if (targetElement) {
                e.preventDefault();
                
                // Use the same offset as TOC links
                const offset = 60;
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
                
                // Smooth scroll to the target
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}